import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {Constants} from '../../Constants';


@Component({
  selector: 'dialog-hang-on',
  templateUrl: './hang-on.component.html',
  styleUrls: ['./hang-on.component.scss']
})
export class HangOnComponent implements OnInit {

  hideHangOn = Constants.hideHangOn;

  msg:string = '';

  constructor( private cdr: ChangeDetectorRef ) { 
  }

  tell(msg){
    this.msg = msg;
    // console.log ( "@@@ tell", msg);
    this.update();
  }

  update() {
    this.cdr.detectChanges();
    // console.log ( "@@@ update");
  }

  ngOnInit() {
  }

}
